import React, { Component } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import NavigationItemInfo from './NavigationItemInfo';
import { DragDropContext } from 'react-beautiful-dnd';
// import { Draggable } from 'react-beautiful-dnd';
import { getBoundingClientRect } from '../../utils/functions';
import DraggableList from '../dragLibrary/DraggableList';

export default class NavigationBasicItem extends Component {

    state = {}

    //     componentDidUpdate(prevProps){
    // if(JSON.stringify(prevProps.tasks) != this.props.tasks){
    //     this.setState({show : true})
    // }
    //     }

    render() {
        const { column, list } = this.props;
        let thisList = list.filter((item) => ((this.props.parent && item.parents.includes(this.props.parent)) || (!this.props.parent && item.parents?.length == 0)))
        // console.log(column)
        return (
            <>
                <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>

                <div className='' >
                    <DraggableList
                        data={list}
                        id={column._id}
                        updatedata={this.props.updatedata}
                        onDragEndAction={this.props.onDragEndAction}
                        setDragInfo={this.props.setDragInfo}
                        dragId={this.props.dragInfo?.id}
                        dragSource={this.props.dragInfo?.source}
                        updateParent={this.props.updateParent}
                        disableDragOver={this.props.disableDragOver}
                        style={{
                            // display: 'flex',
                            // background: (snapshot.isDraggingOver) ? '#007aff10' : null,
                            // border: (snapshot.isDraggingOver) ? '1px dashed #007aff' : '1px dashed transparent',
                            padding: (column._id == 'base' || !column._id) ? '15px 0px' : '8px 0px',
                            borderRadius: 4,
                            minHeight: 20,
                            // marginBottom: 8,
                            // flexDirection: 'column',
                            // flex: 1,
                            width: '100%',
                        }}
                    >


                        {thisList.map((item, index) => {

                            return (

                                <NavigationItemInfo key={item._id}  item={item} index={index} list={this.props.list} onDragEndAction={this.props.onDragEndAction} width={this.props.width} parent={item._id} updatedata={this.props.updatedata} setDragInfo={this.props.setDragInfo} dragInfo={this.props.dragInfo} updateParent={this.props.updateParent} disableDragOver={this.props.disableDragOver} openEdit={this.props.openEdit} />

                            )
                        })}

                        {/* {provided.placeholder} */}

                    </DraggableList>
                    {/* )} */}

                </div >

            </>
        )
    }


}